import { Component, OnInit } from '@angular/core';
import { BaseAPIService } from '@app/Services/api.base.service';

import { IMobileTokenDetail } from '../Models/IMobileTokenDetail';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { IGridCols } from '../Models/IGridCols';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss'],
  providers: [MessageService]
})
export class DeviceComponent implements OnInit {
  mobileInfo: IMobileTokenDetail[];
  cols: Array<IGridCols>;
  mobileUid: string;
  closeResult: string;
  labels: any;
  messages: any;
  noData: boolean = false;
  isPagination: boolean = true;
  isLoading: boolean = false;
  showDeletemodal: boolean = false;
  mobileName: string;

  constructor(private readonly baseService: BaseAPIService, 
    private readonly messageService: MessageService, private readonly translate: TranslateService) { }

  ngOnInit() {
    this.isLoading = true;
    this.labels = label;
    this.messages = message;
    this.cols = [
      { field: 'mobileUId', header: this.labels.mobileUId },
      { field: 'mobileModel', header: this.labels.mobileModel },
      { field: 'mobileOS', header: this.labels.mobileOS },
      { field: 'mobileOSVersion', header: '', display: 'none' },
      { field: 'issuedOn', header: this.labels.mobileIssuedOn }
    ];

    this.noData = false;
    this.GetMobileData();

  }
  public DeleteUserDeveice(rowData: any) {
    this.showDeletemodal = true;
    this.messageService.clear();
    this.mobileUid = rowData.mobileUId;
  }

  onConfirm() {
    this.messageService.clear('c');
    this.isLoading = true;
    this.baseService.DELETE(`/MobileUserManagement/MobileAccessToken/${this.mobileUid}`).subscribe((result) => {
      if (result === null) {
        this.isLoading = false;
        this.showDeletemodal = false;
        this.GetMobileData();
        this.messageService.add({ severity: 'success', summary: this.translate.instant('Success'), detail: this.translate.instant('Device info Deleted Successfully'), key: 'success' });

      }
      else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant('Error'), detail: this.translate.instant('Some error occured'), key: 'error' });

      }
    })
  }

  onReject() {
    this.messageService.clear('c');
  }

  public GetMobileData() {
    this.baseService.GET('/MobileUserManagement/AllMobileUserDetailsByUser/').subscribe((result: IMobileTokenDetail[]) => {

      if (result != null && result.length > 0) {
        this.mobileInfo = result;
        if (this.mobileInfo.length < 10) {
          this.isPagination = false;
        }
      }
      else {
        this.mobileInfo = null;
        this.noData = true;
        this.isPagination = false;
      }
      this.isLoading = false;
    })
  }
  public close() {
    this.showDeletemodal = false;
  }

}
